import instance from './instance'
import * as users from './users'
import * as invites from './invites'
import * as organizations from './organizations'
import * as addresses from './addresses'
import * as contracts from './contracts'
import * as customers from './customers'

export default {
  instance,
  users,
  invites,
  organizations,
  addresses,
  contracts,
  customers,
}
